import { Controller } from 'stimulus'

export default class extends Controller {
  show() {
    Turbolinks.visit('/__better_errors')
  }
}
